/**
 * Cliente do painel do fabricante (módulo `fabricante`, ADR 0006).
 *
 * Reusa o axios instance `api` com interceptor JWT do services/api.js.
 * As rotas só existem em instância com AURA_FABRICANTE=1.
 */

import api from './api';

const BASE = '/fabricante';

function unwrap(promise) {
  return promise.then((r) => r.data);
}

export const fabricanteAPI = {
  listarEmpresas: () => unwrap(api.get(`${BASE}/empresas`)),
  criarEmpresa: (body) => unwrap(api.post(`${BASE}/empresas`, body)),
  atualizarEmpresa: (id, body) => unwrap(api.patch(`${BASE}/empresas/${id}`, body)),
  criarAdmin: (empresaId, body) =>
    unwrap(api.post(`${BASE}/empresas/${empresaId}/admins`, body)),

  // Trilha de acesso: quem olhou dado sensível, quando e de onde.
  resumoTrilha: (horas) => unwrap(api.get(`${BASE}/trilha/resumo`, { params: { horas } })),
  listarTrilha: (params) => unwrap(api.get(`${BASE}/trilha`, { params })),
  sessoes: (dias) => unwrap(api.get(`${BASE}/trilha/sessoes`, { params: { dias } })),
};

export default fabricanteAPI;
